<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up" style="width:auto">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="() => { $emit('close') }">&times;</button>
            </div>

            <div v-if="$store.state.user.teamHubRole == 'Admin'" style="margin-bottom:20px;display:flex">
                <div v-if="!editing" class="add-btn" @click="() => { editing = true; }">Edit</div>
                <div v-else class="add-btn" @click="() => { editing = false; }">Stop Editing</div>
            </div>

            <div v-if="editing" style="margin-bottom:35px">
                <div v-if="saving" style="font-weight:bold">Saving...</div>
                <div v-else-if="saved" style="color:green;font-weight:bold">All Changes Saved.</div>
                <div v-else>&nbsp;</div>
            </div>

            <div class="playbook-sheet-wrap company-sheet-wrap team-hub-sheet-wrap" :style="editing ? 'overflow:visible;max-height:100%!important;' : 'overflow:visible;max-height:100%!important;pointer-events:none!important'">
                <table id="playbook-sheet" class="playbook-sheet">
                    <draggable :list="formData.sheetJSON.rows" tag="tbody" @change="debounceSubmit()">
                        <tr v-for="(row, i) in formData.sheetJSON.rows" :key="'r'+i">
                            <td v-for="(col, j) in row" :key="'c'+j" @contextmenu="cellRightClick($event, i, j)" :class="'playbook-sheet-cell-' + col.style">
                                <div><textarea v-model="col.text" @input="debounceSubmit()" spellcheck="false"></textarea></div>
                            </td>
                        </tr>
                    </draggable>
                </table>
            </div>
        </div>

        <div v-if="showRightClickMenu" class="form-wrapper link-pop" :style="`top: ${rightClickY - 20}px; left: ${rightClickX}px`">
            <span class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="() => { showRightClickMenu = false }">&times;</button>
            </span>
            <div><a @click.prevent="addRow(rightClickCellRow)">Add Row Above</a></div>
            <div><a @click.prevent="addRow(rightClickCellRow + 1)">Add Row Below</a></div>
            <div><a @click.prevent="addCol(rightClickCellCol)">Add Col Left</a></div>
            <div><a @click.prevent="addCol(rightClickCellCol + 1)">Add Col Right</a></div>
            <div><a @click.prevent="removeRow(rightClickCellRow)">Delete Row</a></div>
            <div><a @click.prevent="removeCol(rightClickCellCol)">Delete Col</a></div>
            <div>
                <select v-model="formData.sheetJSON.rows[rightClickCellRow][rightClickCellCol].style" style="margin: 0;" @change="menuValueChange()">
                    <option :value="undefined">Regular</option>
                    <option value="red">Primary</option>
                    <option value="gray">Gray</option>
                    <option value="noborder">No Border</option>
                </select>
            </div>
        </div>

        <confirm-delete v-if="showConfirmColRemove" @confirm="removeColCB" @cancel="() => { showConfirmColRemove = false; }" msg="Are you sure you would like to delete this col?"/>
        <confirm-delete v-if="showConfirmRowRemove" @confirm="removeRowCB" @cancel="() => { showConfirmRowRemove = false; }" msg="Are you sure you would like to delete this row?"/>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import ConfirmDelete from './ConfirmDelete.vue';
import { VueDraggableNext } from 'vue-draggable-next';

export default defineComponent({
    name: 'TeamHubSheet',
    props: [ 'id' ],
    components: {
        ConfirmDelete,
        draggable: VueDraggableNext,
    },
    data() {
        return {
            loaded: false,
            formData: {
                id: -1,
                sheetJSON: {
                    rows: [
                        [
                            {
                                text: 'Column 1'
                            },
                            {
                                text: 'Column 2'
                            },
                            {
                                text: 'Column 3'
                            },
                        ] as any
                    ]
                }
            },
            rightClickX: 0,
            rightClickY: 0,
            rightClickCellRow: 0,
            rightClickCellCol: 0,
            showRightClickMenu: false,
            colToRemove: 0,
            showConfirmColRemove: false,
            rowToRemove: 0,
            showConfirmRowRemove: false,
            submitDebounceTimer: null as any,
            saving: false,
            saved: false,
            editing: false
        }
    },
    async created() {
        this.formData.id = this.id;
        await axios.get(`${this.$store.state.apiUrl}/api/teamhublinks/sheet/${this.formData.id}`)
            .then(resp => {
                if(resp.data.SheetJSON) {
                    this.formData.sheetJSON = JSON.parse(resp.data.SheetJSON);
                }
            })
            .catch(e => {
                console.log(e);
            })

        this.loaded = true;
    },
    methods: {
        cellRightClick(e: any, i: number, j: number) {
            e.preventDefault();
            this.rightClickX = e.clientX;
            this.rightClickY = e.clientY;
            const elBottom = this.rightClickY + 320;
            if(elBottom > window.innerHeight) {
                this.rightClickY = window.innerHeight - 320;
            }
            this.rightClickCellRow = i;
            this.rightClickCellCol = j;
            this.showRightClickMenu = true;
        },
        debounceSubmit() {
            this.saving = true;
            this.saved = false;
            clearTimeout(this.submitDebounceTimer);
            this.submitDebounceTimer = setTimeout(() => { this.submit(); }, 2000);
        },
        async submit() {
            await axios.post(`${this.$store.state.apiUrl}/api/teamhublinks/updatesheet`, this.formData)
                .then(resp => {
                    this.saving = false;
                    this.saved = true;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        addRow(index: any) {
            const colLength = this.formData.sheetJSON.rows[0].length;
            const newRow = [];
            for(let i = 0; i < colLength; i++) {
                newRow.push({
                    text: ''
                })
            }
            if(index === null) {
                this.formData.sheetJSON.rows.push(newRow);
            } else {
                this.formData.sheetJSON.rows.splice(index, 0, newRow);
            }
            this.showRightClickMenu = false;
            this.debounceSubmit();
        },
        addCol(index: any) {
            if(index === null) {
                for(const row of this.formData.sheetJSON.rows) {
                    const newCol = {
                        text: ''
                    }
                    row.push(newCol);
                }
            } else {
                for(const row of this.formData.sheetJSON.rows) {
                    const newCol = {
                        text: ''
                    }
                    row.splice(index, 0, newCol);
                }
            }

            this.showRightClickMenu = false;

            this.debounceSubmit();
        },
        removeCol(index: number) {
            this.colToRemove = index;
            this.showConfirmColRemove = true;
        },
        removeRow(index: number) {
            this.rowToRemove = index;
            this.showConfirmRowRemove = true;
        },
        removeColCB() {
            for(const row of this.formData.sheetJSON.rows) {
                row.splice(this.colToRemove, 1);
            }
            this.showRightClickMenu = false;
            this.showConfirmColRemove = false;
            this.debounceSubmit();
        },
        removeRowCB() {
            if(this.formData.sheetJSON.rows.length == 1) {
                this.showRightClickMenu = false;
                return;
            }
            this.formData.sheetJSON.rows.splice(this.rowToRemove, 1);
            this.showRightClickMenu = false;
            this.showConfirmRowRemove = false;
            this.debounceSubmit();
        },
        menuValueChange() {
            this.debounceSubmit();
            this.showRightClickMenu = false;
        }
    }
})
</script>